import React from 'react';
import { SwapItem } from '../Swap';
export const CodeInfo = props => {
  return React.createElement(SwapItem, props, props.children);
};
CodeInfo._type = 'info';